import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import WithDrawMenu from './WithDrawMenu'
import { CreateUserWalletWithDrawService, UpdateUserWalletWithDrawService, UploadUserWalletWithDrawService } from '../../services/WithDrawRequestServices'
import Uploader from '../../components/Uploader'
import { useSelector } from 'react-redux'
import DashboardMenu from '../dashboard/DashboardMenu'
import { GetDashboardService } from '../../services/DashboardServices'

function WithDrawCE() {

 


  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();


  const pathname = location.pathname.split('/')[2]
  const pathname1 = location.pathname.split('/')[3]
  
  
  const roles = useSelector(state=>state.Auth.roles)
  
  
  const status_arr = [{label:'Pending',value:'Pending'},{label:'Approved',value:'Approved'},{label:'Rejected',value:'Rejected'}]

  const [data, setdata] = useState({amount: '', status: '', description: '',remarks:'',file:'',file1:''});
  const [error, seterror] = useState({amount: '', status: '', description: '',remarks:'',file:'',file1:''});

  const [mainData,setmainData] = useState({})

  async function getdata() {
    const response = await GetDashboardService()
    setmainData(response?.data?.data)
  }

  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {
      let oldData = {...state,status:{label:state?.status,value:state?.status}}
      delete oldData.user
      delete oldData.updated_by
      setdata({ ...data, ...oldData })
    }
    getdata()
  }, [state])

  function handlechange(e) {
    setdata({ ...data, [e.target.name]: e.target.value })
    seterror({ ...error, [e.target.name]: '' })
  }

  async function UploadFile(v,name){
    const fd = new FormData()
    fd.append('file',v); 
    const response = await  UploadUserWalletWithDrawService(fd)
    if(response?.status === 200){
      setdata({...data,[name]:response?.data?.data})
      seterror({...error,[name]:''})
    }
  }




  async function submitform() {
   
    if(data?.amount > mainData?.userWalletInfo){
      toast.error("Requested Amount is higher than Balance")
    }else{

    if (!data.amount) {
      seterror({ ...error, amount: 'Name field is required *' })
    }else if (!data.file1) {
      seterror({ ...error, file1: 'Name field is required *' })
    }else {
      let sendData = { ...data }
      if(data?.status?.label !== undefined){
        sendData['status'] =  data?.status?.label
      }else{
        delete sendData.status
      }

      if (state?._id === undefined || state?._id === null) {
        const response = await CreateUserWalletWithDrawService(sendData)
        if (response.status === 201) {
          resetform()
          toast.success('User Wallet Withdraw Created Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      } else {
        sendData["id"] = state?._id
        console.log("sendData",sendData)
        const response = await UpdateUserWalletWithDrawService (sendData, state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('User Wallet Withdraw Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      }
     }
    }
  }

  async function resetform() {
    setdata({amount: '', status: '', description: '',remarks:'',file:'',file1:''})
    seterror({amount: '', status: '', description: '',remarks:'',file:'',file1:''})

  }

 
  function handleSelect(e,e1){
    setdata({...data,[e1]:{label:e,value:e}})
    seterror({...error,[e1]:''})
  }

  
  // console.log("mainData",mainData)

  function formatToCurrency(amount){
   return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(parseInt(amount)).split('.')[0]
  }
 
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

     

      <div>
      {pathname == 'withdraw_request' ? 
      <DashboardMenu /> 
      :
      <WithDrawMenu />}
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full lg:w-[300px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} WithDraw Request</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>WithDraw Request details</b> assign to you!.</h6>

          


          <TextInput 
            label={'Amount'}
            mandatory={true}
            variant="standard"
            name="amount"
            type="number"
            error={error.amount}
            value={data.amount}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

          <Uploader error={error?.file1} name="file1" required={true} label={'Bank / UPI Image'} image={data?.file1}  setimagefunc={(e)=>{UploadFile(e,'file1');seterror({...error,file1:''})}}  removeimageuploadfunc = {()=>{setdata({...data,file1:''});seterror({...error,file1:''})}} />


          <h6 className='text-[10px] mt-2 bg-blue-100 p-2 font-[500] leading-snug' >The total amount available for withdraw  is <b>{formatToCurrency(mainData?.userWalletInfo)}</b> and make sure you don't create multiple withdraw.</h6>


         
        
           
           {/* <TextAreaInput1
            type="text"
            label={'Description'}
            mandatory={false}
            variant="standard"
            name="description"
            error={error.description}
            value={data.description}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}
             /> */}

            {roles?.includes('admin') && 
            <>
            <h6 className='text-[12px] font-[400] mb-1 mt-1'>Status</h6>
            <Select
              value={data.status} 
              error={error.status}
              bordered={false}
              placeholder="" 
              onChange={(e)=>handleSelect(e,'status')} 
              options={status_arr} 
              style={{fontSize:'12px'}}
              // border-l-4 border-l-slate-700 
              className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
              />   

          <ErrorComponent  error={error?.status} />  

           

          <Uploader error={error?.file} name="file" required={false} label={'Payment Attachment'} image={data?.file}  setimagefunc={(e)=>{UploadFile(e,'file');seterror({...error,file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,file:''});seterror({...error,file:''})}} />

        
         <TextAreaInput1
            type="text"
            label={'Remarks'}
            mandatory={false}
            variant="standard"
            name="remarks"
            error={error.remarks}
            value={data.remarks}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}
             />

         </>} 

        {/* <h6>{pathname1}</h6> */}
       
       {/* (mainData?.userWalletInfo > parseInt(data?.amount))  */}

        {(pathname1 !== 'create' && (roles?.includes('wfh') || roles?.includes('admin'))) || (roles?.includes('admin'))  &&   
        <div className='mt-4'>
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>}

        </div>

    

      
      </div>

      
      </div> 

    </div>
  )
}

export default WithDrawCE